module.exports = __webpack_public_path__ + "static/media/infrastructure.87e18e78.jpg";